import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useCustomerOrderReportQuery, useSalesReportQuery } from '../../../../Store/Apis/reportApi';
import Error from '../../../../Components/Error/Error';
import Loader from '../../../../Components/Loader/Loader';
import { useOutletsQuery } from '../../../../Store/Apis/outletApi';
import { useStatusQuery } from '../../../../Store/Apis/bookingApi';
import getStatusColor from '../../../../Hooks/GetStatusColor';
import { useSupplierInvoiceByIdQuery, useSupplierListQuery } from '../../../../Store/Apis/supplierApis';
import { useSelector } from 'react-redux';

const PrintStockRequsition = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const invoiceNumber = queryParams.get('invoiceNumber');
    const [logoLoaded, setLogoLoaded] = useState(false); // Track logo loading state
    const user = useSelector((state) => state.auth.user);

    const requisitionById = useSupplierInvoiceByIdQuery({
        REQUE: invoiceNumber
    }, {skip: !invoiceNumber})
    
    useEffect(() => {
           const sidebar = document.querySelector('aside.sidenav');
           const mainContent = document.querySelector('.sidenav.fixed-start + .main-content');
           const navbar = document.querySelector('.navbar-main');
         
           if (sidebar) sidebar.style.display = 'none';
           if (mainContent) mainContent.style.marginLeft = '0';
           if (navbar) navbar.style.display = 'none';
         }, []);
    useEffect(() => {
        if (requisitionById.isSuccess && logoLoaded) {
            // Open print dialog on success
            window.print();

            // Close the page when the print dialog is closed
            const handleAfterPrint = () => {
                window.close();
            };

            window.addEventListener('afterprint', handleAfterPrint);

            return () => {
                window.removeEventListener('afterprint', handleAfterPrint);
            };
        }
    }, [requisitionById.isSuccess, window, logoLoaded]);

    if (!requisitionById.isSuccess) {
        return null;
    }

    const invoice = requisitionById.isSuccess && requisitionById.data.data[0]

    return (
        <div className='card' id="invoice">
            <div className="card-body p-0">
                <div className="page-wrapper" style={{ padding: 15 }}>
                    {requisitionById.isError && <Error />}
                    {(requisitionById.isLoading || requisitionById.isFetching) && <Loader height="300px" />}
                    {(!requisitionById.isLoading && !requisitionById.isFetching) && (
                        <>
                            
                            <div>
                                
                                <table className='table mb-3'>
                                    <tbody>
                                        <tr>
                                            <td className='px-0 border-0'>
                                                <img
                                                    src={user?.logo}
                                                    alt="Logo"
                                                    height={70}
                                                    className="mb-3"
                                                    onLoad={() => setLogoLoaded(true)} // Mark logo as loaded
                                                />

                                                <p className='mb-0 text-sm fw-bold'>Company Details</p>
                                                <div className='text-dark text-sm'>{invoice.supplierName}</div>
                                            </td>
                                            <td className='px-0 border-0 text-end'>
                                                <p className='text-sm mb-0 text-dark'>Requisition NO : {invoice.invoiceNumber}</p>
                                                <p className='text-sm mb-0 text-dark'>Requisition Date : {invoice.invoiceDate.split("T")[0]}</p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <h4 className='text-center mb-4'>External Stock Requisition</h4>
                                <table className="table table-bordered mb-4">
                                    <thead className="bg-light">
                                        <tr>
                                            <th className="text-uppercase text-secondary text-xs px-4">SR NO.</th>
                                            <th className="text-uppercase text-secondary text-xs px-4">Products</th>
                                            <th className="text-uppercase text-secondary text-xs px-4">QTY</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {invoice.childRecords.map((record, i) => (
                                        <tr key={i}>
                                            <td className='text-sm px-4'>{i+1}</td>
                                            <td className='text-sm px-4'>{`${record.productName} [${record.name}]`}</td>
                                            <td className='text-sm px-4'>{record.quantity}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>

                                <p className='text-sm'>
                                    Note: {invoice.invoiceNote}
                                </p>

                                <table className='w-100 mb-5'>
                                    <tbody>
                                        <tr>
                                            <td className='w-50'>
                                                <p className='mb-2 text-sm'>Authorisation</p>
                                            </td>
                                            <td className='w-50'>
                                                
                                                <p className='mb-0 text-sm'>Manager Signature:</p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

export default PrintStockRequsition;
